import { startsWith, some, toLower } from "lodash"
import { track } from "helpers/analytics"

export function matchATForecastByName(name, forecasts) {
  if (startsWith(name, "AT-")) {
    return some(forecasts, ({ name: forecastName }) =>
      toLower(forecastName).indexOf(toLower(name.replace(/^AT-/, ""))) !== -1,
    )
  }
  return false
}

export function trackPortfolioLoaded(portfolioId, portfolioName, pathname) {
  track("portfolio-loaded", {
    portfolio_id: portfolioId,
    portfolio_name: portfolioName,
    pathname,
  })
}
